import { appConfig } from '@ami/react/core';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { ProductGroupMarketingComponent } from '../../../products/components/ProductGroupMarketingComponent';
import { ProductConfiguration } from '../../../products/productConfiguration';
import {
  QuoteProductCustomization,
  QuoteProductDimension,
} from '../../../quotes/otherQuoteEntities';
//import './QuoteProductDetails.scss';
import { isAmiUserGlobalAdministrator } from '../../../authorization/amiPermissions';
import { productGroupDimensionCategory } from '../../../products/productGroupDimensionCategoryType';
import QuoteProductDetail from '../../../quotes/entities/quoteProductDetail';
import ProductThumbSpecificationsModal from '../../../quotes/review/quote-products/ProductThumbSpecificationsModal';

const QuoteProductDimensionComponent = ({
  dimension,
  noBucketSpecsAvailable,
}) => {
  if (dimension.type !== 'MultiLine') {
    var value = dimension.value;
    if (
      dimension.category === productGroupDimensionCategory.Width &&
      noBucketSpecsAvailable
    ) {
      value = 'TBD';
    }
  }

  return (
    <div className="row">
      <div className="col-auto text-nowrap">{`${dimension.name}:`}</div>
      <div className="col-auto text-break-line">{value}</div>
    </div>
  );
};

const QuoteStandaloneComponent = ({ partNumber, name, description }) => {
  return (
    <div className="row">
      {partNumber && partNumber !== null && (
        <Fragment>
          <div className="col-auto text-nowrap">
            <strong>{partNumber}</strong>
          </div>
          -
        </Fragment>
      )}
      <div className="col-auto text-break-line">
        <div>{name}</div>
        <div>{description}</div>
      </div>
    </div>
  );
};




export default class QuoteProductDetails extends React.PureComponent {
  constructor(props) {
    super(props);
    this.productThumbSpecificationsModalRef = React.createRef();
  }

  static propTypes = {
    quoteProductId: PropTypes.any,
    productGroupImageUrl: PropTypes.string,
    productGroupName: PropTypes.string.isRequired,
    productGroupDescription: PropTypes.string,
    productPartNumber: PropTypes.string.isRequired,
    productOptions: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        partNumber: PropTypes.string,
        description: PropTypes.string,
      })
    ).isRequired,
    standaloneComponents: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        partNumber: PropTypes.string.isRequired,
      })
    ).isRequired,
    customizations: PropTypes.arrayOf(
      PropTypes.instanceOf(QuoteProductCustomization)
    ).isRequired,
    dimensions: PropTypes.arrayOf(PropTypes.instanceOf(QuoteProductDimension))
      .isRequired,
    marketing: PropTypes.shape({
      supportsHardox: PropTypes.bool.isRequired,
      supportsStrenx: PropTypes.bool.isRequired,
    }).isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    notes: PropTypes.string,
    manufacturingInstructions: PropTypes.string,
    paintColor: PropTypes.string,
    notesFieldName: PropTypes.string,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    onAddCustomization: PropTypes.func,
    onRemoveCustomization: PropTypes.func,
    onOverridePricing: PropTypes.func,
    quote: PropTypes.object.isRequired,
    productDetail: PropTypes.object,
  };

  getProductDetail() {
    const { productDetail } = this.props;
    return new QuoteProductDetail(productDetail);
  }

  isThumbMustBeReEntered() {
    const { quote, productDetail } = this.props;

    if (productDetail && productDetail.bucketQuoteProductId) {
      const bucketQuoteProduct = quote.products.find(
        (x) => x.id === productDetail.bucketQuoteProductId
      );
      if (!bucketQuoteProduct) return true;
    }
  }

  render() {
    const {
      quoteProductId,
      productGroupImageUrl,
      productGroupName,
      productGroupDescription,
      productPartNumber,
      productPartNumberIncomplete,
      productOptions,
      standaloneComponents,
      customizations,
      dimensions,
      productConfiguration,
      marketing,
      notes,
      manufacturingInstructions,
      paintColor,
      notesFieldName,
      onEdit,
      onRemove,
      onAddCustomization,
      onRemoveCustomization,
      onOverridePricing,
      productDetail,
      quote,
    } = this.props;

    const noBucketSpecsAvailable =
      productDetail && this.getProductDetail().noBucketSpecsAvailable();

    return (
      <Fragment>
        <td>
          <img
            src={productGroupImageUrl}
            className="product-group-image img-fluid"
            alt={productGroupName}
          />
          <ProductGroupMarketingComponent
            marketing={marketing}
            productConfiguration={productConfiguration}
          />
        </td>
        <td className="product-details">
          <div className="row">
            <div className="col">
              <div className="row highlight">
                <div className="col-10 group-name">{productGroupName}</div>
                {onEdit && (
                  <div className="col-1"><span className="icon icon-edit text-primary cursor-pointer"
                    onClick={() => onEdit(quoteProductId)}
                  />  </div>)}
                {onRemove && (
                  <div className="col-1"><span className="icon icon-trash text-danger cursor-pointer"
                    onClick={() => onRemove(quoteProductId)}
                  />  </div>)}
              </div>
              <div>{productGroupDescription}</div>
              <div className="part-number">
                <strong>{productPartNumber}</strong>{' '}
                {appConfig.isManagementApp && productPartNumberIncomplete && (
                  <span className="badge text-bg-warning">Partial</span>
                )}
              </div>
              <div className="dimensions">
                {dimensions
                  .filter((x) => !x.hideFromOnline)
                  .map((x) => (
                    <QuoteProductDimensionComponent
                      dimension={x}
                      key={x.id}
                      noBucketSpecsAvailable={noBucketSpecsAvailable}
                    />
                  ))}

                { paintColor && (<div className="row">
                  <div className="col-auto text-nowrap">Paint:</div>
                  <div className="col-auto text-break-line">{paintColor}</div>
                </div>
                )}

              </div>
              <div className="options">
                <table className="detail-table ">
                  <tbody>
                    {productOptions.map((x, key) => (
                      <tr key={key}>
                        <td className="align-middle text-start" key={x.name}>
                          {((x.partNumber && x.partNumber !== null) ||
                            !x.standaloneComponents ||
                            x.standaloneComponents.length === 0) && (
                              <QuoteStandaloneComponent
                                partNumber={x.partNumber}
                                name={x.name}
                                description={x.description}
                              />
                            )}
                          {x.standaloneComponents &&
                            x.standaloneComponents.map((c) => (
                              <QuoteStandaloneComponent
                                key={`${c.partNumber}${c.name}`}
                                partNumber={c.partNumber}
                                name={c.name}
                              />
                            ))}
                        </td>
                        {x.imageUrl !== undefined ? (
                          <td>
                            <img
                              src={x.imageUrl}
                              className="product-option-image img-fluid"
                              alt={x.name}
                            />
                          </td>
                        ) : null}
                      </tr>
                    ))}
                    {standaloneComponents &&
                      standaloneComponents.map((x, key) => (
                        <tr key={key}>
                          <td className="align-middle text-start" key={x.name}>
                            <QuoteStandaloneComponent
                              key={key}
                              partNumber={x.partNumber}
                              name={x.name}
                            />
                          </td>
                        </tr>
                      ))}
                    {customizations.map((x, idx) => (
                      <tr key={idx}>
                        <td className="align-middle text-start">
                          <span>
                            {x.partNumber} - {x.description}
                          </span>
                        </td>
                        <td>
                          {onRemoveCustomization &&
                            appConfig.isManagementApp && (
                              <button
                                className="btn btn-link text-danger p-0 ms-1"
                                type="button"
                                onClick={() =>
                                  onRemoveCustomization(quoteProductId, idx)
                                }
                              >
                                remove
                              </button>
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {notes && notesFieldName && (
                  <div>
                    {notesFieldName} - {notes}
                  </div>
                )}
              </div>
            </div>
          </div>

          {productDetail && !onEdit && (
            <div className="row text-start">
              <div className="col-6">
                <button
                  className="btn btn-link ps-0 pt-1 pe-1 pb-1"
                  type="button"
                  onClick={() =>
                    this.productThumbSpecificationsModalRef.current.show()
                  }
                >
                  view thumb specifications
                </button>
              </div>
            </div>
          )}
          {quoteProductId &&
            (onEdit || onRemove || onAddCustomization || onOverridePricing) && (
              <div>
                <div className="row text-start">
                  {onAddCustomization && appConfig.isManagementApp && (
                    <div className="col-6">
                      <button
                        className="btn btn-link ps-0 pt-1 pe-1 pb-1"
                        type="button"
                        onClick={() => onAddCustomization(quoteProductId)}
                      >
                       add custom product option
                      </button>
                    </div>
                  )}
                </div>
                <div className="row text-start">
                  {isAmiUserGlobalAdministrator() &&
                    onOverridePricing &&
                    appConfig.isManagementApp && (
                      <div className="col-6">
                        <button
                          className="btn btn-link ps-0 pt-1 pe-1 pb-1"
                          type="button"
                          onClick={() => onOverridePricing(quoteProductId)}
                        >
                          override pricing
                        </button>
                      </div>
                    )}
                </div>

                <div className="row text-start">
                  {this.isThumbMustBeReEntered() && (
                    <div className="col-12">
                      <div className={`alert alert-danger card-body`}>
                        <i className="fa fa-info-circle fa-lg"></i> The bucket
                        details for this thumb must be re-entered
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            { manufacturingInstructions && (
            <div className="row text-start">
                <div>
                  <div className="col group-name">Customization Request</div>
                    <div className="col text-break-line">{manufacturingInstructions}</div>
                </div>
            </div>
              )}
        </td>
        {productDetail && !onEdit && (
          <ProductThumbSpecificationsModal
            entity={this.getProductDetail()}
            ref={this.productThumbSpecificationsModalRef}
            productGroupName={productGroupName}
            quote={quote}
          />
        )}
      </Fragment>
    );
  }
}
